/**
 * Validates if a JWT token is expired
 * @param {string} token - JWT token string
 * @returns {boolean} - true if token is valid (not expired), false otherwise
 */
export const isTokenValid = (token) => {
  try {
    if (!token) return false;

    const parts = token.split(".");
    if (parts.length !== 3) return false;

    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token has expiration (exp claim)
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      // Token is valid if expiration time is in the future
      return payload.exp > currentTime;
    }

    // If no exp claim, assume token is valid (some tokens don't expire)
    return true;
  } catch (err) {
    console.error("Token validation failed", err);
    return false;
  }
};

/**
 * Gets token expiration time in milliseconds
 * @param {string} token - JWT token string
 * @returns {number|null} - Expiration timestamp in ms, or null if not available
 */
export const getTokenExpiration = (token) => {
  try {
    if (!token) return null;

    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const payload = JSON.parse(atob(parts[1]));
    
    if (payload.exp) {
      return payload.exp * 1000; // Convert to milliseconds
    }

    return null;
  } catch (err) {
    console.error("Failed to get token expiration", err);
    return null;
  }
};
